import PropTypes from 'prop-types';
import React, { useState } from 'react';
import LoadingSpinner from '../shared/LoadingSpinner';
import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import Phone from '../Phone';
import * as styles from './styles.module.scss';
import useLanguageRegionCode from '../../hooks/useLanguageRegionCode';

function ShareModalDrawerTextMessage({ sendSMSMessage, shareObject }) {
  const languageRegionCode = useLanguageRegionCode();
  const [showSpinner, setShowSpinner] = useState(false);
  const [buttonLabel, setButtonLabel] = useState(StringConstantsMixin.strings.MOBILE.TEXT_LINK);
  const [isValid, setIsValid] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');

  function handleChange(isValid, newNumber, countryData, fullNumber) {
    setIsValid(isValid);
    setPhoneNumber(fullNumber);
  }

  function sendTextMessage() {
    setShowSpinner(true);
    sendSMSMessage(phoneNumber, shareObject, languageRegionCode, () => {
      setShowSpinner(false);
      setButtonLabel(StringConstantsMixin.strings.FAILED);
    });
  }

  let button;

  if (showSpinner) {
    button = (
      <div className="send-sms-msg-ellipsis">
        <LoadingSpinner />
      </div>
    );
  } else {
    button = (
      <button className="send-sms-msg" disabled={!isValid} onClick={sendTextMessage} type="button">
        {buttonLabel}
      </button>
    );
  }

  return (
    <div className="form-holder">
      <p>{StringConstantsMixin.strings.SHARE_MODAL.SMS_INSTRUCTIONS}</p>
      <div className={styles.messagingContainer}>
        <Phone onChange={handleChange} />
        {button}
      </div>
    </div>
  );
}

ShareModalDrawerTextMessage.propTypes = {
  sendSMSMessage: PropTypes.func.isRequired,
  shareObject: PropTypes.shape({
    type: PropTypes.string.isRequired
  }).isRequired
};

export default ShareModalDrawerTextMessage;
